import React from "react";
import { useNavigate } from "react-router-dom";
import { getSavedUser } from "./lib/globalfunction";

const Header = (props) => {
  const navigate = useNavigate();

  function BackToHome() {
    navigate(props.BackTo);
  }

  return (
    <div className="p-6 pt-12 glass flex justify-between items-center shrink-0 z-50">
      {props.BackTo && (
        <button
          onClick={BackToHome}
          className="p-2 bg-cyan-500/10 hover:bg-cyan-500/20 rounded-full text-cyan-400 transition-colors cursor-pointer"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 19l-7-7 7-7"
            ></path>
          </svg>
        </button>
      )}

      <div>
        <h2 className="font-bold text-lg">
          {process.env.REACT_APP_SITE_TITLE}
        </h2>
        <p className="text-xs text-accent">{getSavedUser()?.FacilityName}</p>
      </div>

      <div />
    </div>
  );
};

export default Header;
